import { dataSearch } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSearch = /*#__PURE__*/createIcon(dataSearch)
export default IconSearch
